import { FormControl, FormGroup, FormLabel, TextField } from "@mui/material";
import { FaireSettings } from "../../api";
import { PasswordField } from "../controls";

export interface FaireSettingsControlProps {
  settings?: FaireSettings;
  onChange: (settings: Partial<FaireSettings>) => void;
}

export const FaireSettingsControl = (props: FaireSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">Faire settings</FormLabel>
      <FormGroup>
        <TextField label="ApiKey" required variant="standard" value={settings?.apiKey ?? ""} onChange={(e) => onChange({ apiKey: e.target.value })} />
      </FormGroup>
    </FormControl>
  );
};
